<template>
  <div class="main personalPage">
    <div class="margin-left clearfix main-second-bg">
      <div class="margin-left clearfix">
        <div class="title b-1-cl medium-fonts medium">
          {{ this.$t("personal.navMenu.title") }}
        </div>
        <c-navMenu
          :width="310"
          activeColor="b-1-cl"
          :navList="navList"
          :navListActive="navListActive"
          @listChange="listChanges"
        />
      </div>
    </div>
    <div class="margin-right clearfix">
      <div class="margin-right-bar">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'personal',
  data() {
    return {
      navListActive: 'userManagement',
      pageTitleText: null,
      coAgentFlag: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.navListActive = this.$route.meta.navName;
      if (this.navList.length) {
        this.navList.forEach((item) => {
          if (this.navListActive === item.id) {
            this.pageTitleText = item.navText;
          }
        });
      }
      if (this.coinsKrwOpen === '1') {
        this.krwGetUserBack();
      }
      // this.getCoAgentFlag();
    },
    getCoAgentFlag() {
      this.axios({
        url: 'common/public',
        hostType: 'fe-increment-api',
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.coAgentFlag = data.data.coAgentStatus;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    listChanges(data) {
      this.navListActive = data.id;
      this.pageTitleText = data.navText;
      this.$router.push(`/personal/${data.id}`);
      this.$store.dispatch('setModifyApiShow', false);
    },
    // 获取当前用户的银行账号 -- krw定制
    krwGetUserBack() {
      this.$store.dispatch('krwGetUserBank');
    },
  },
  computed: {
    fiatTradeOpen() {
      const base = this.$store.state.baseData.publicInfo;
      if (base && base.switch && base.switch.fiat_trade_open === '1') {
        return true;
      }
      return false;
    },
    coinsKrwOpen() {
      const { publicInfo } = this.$store.state.baseData;
      let str = '0';
      if (publicInfo && publicInfo.switch && publicInfo.switch.coins_krw_open) {
        str = publicInfo.switch.coins_krw_open.toString();
      }
      return str;
    },
    linkurl() {
      if (this.$store.state.baseData.publicInfo) {
        return this.$store.state.baseData.publicInfo.url;
      }
      return {};
    },
    navList() {
      const arr = [
        {
          iconClass: 'iconClass',
          navText: this.$t('personal.navMenu.list.userManagement'),
          href: '',
          type: 1,
          icon: 'personalAccountIcon',
          id: 'userManagement',
        },
        {
          iconClass: 'iconClass',
          navText: this.$t('personal.navMenu.list.safetyRecord'),
          href: '',
          type: 2,
          activeIconSvg: '',
          iconSvg: '',
          id: 'safetyRecord',
        },
      ];
      arr.push({
        // 法币设置
        navText: this.fiatTradeOpen
          ? this.$t('assets.b2c.otcShow.leaglTenderSet')
          : this.$t('personal.navMenu.list.leaglTenderSet'),
        type: 1,
        id: 'leaglTenderSet',
      });
      return arr;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    metaText() {
      return this.$route.meta.navName;
    },
  },
  watch: {
    coinsKrwOpen(v) {
      if (v === '1') {
        this.krwGetUserBack();
      }
    },
    metaText(metaText) {
      this.navListActive = metaText;
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  min-height: 800px;
  margin: 40px auto;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  gap: 24px;
  font-family: 'Medium';

  .margin-left {
    width: 310px;
    min-height: 800px;
    border-radius: 6px;

    .title {
      font-size: 16px;
      margin: 20px 0 20px 20px;
    }
  }

  .margin-right {
    width: 980px;
    min-height: 800px;
    border-radius: 6px;
  }
}
</style>
